import React, { useEffect, useRef, useState } from 'react';
import {
    TradeContainer,
    TradeContent
} from '../../../../styles/TradeDocStyles';
import FormHeader from '../../../../components/dashboard/tradeDocuments/common/FormHeader';
import { useLocation, useNavigate } from 'react-router-dom';
import useCorporatePartners from '../../../../customhooks/useCorporatePartners';
import { nanoid } from '@reduxjs/toolkit';
import { openNotification } from '../../../../utils/helper';
import {
    createProformaInvoice,
    getSingleDocuments
} from '../../../../api/documents/documents';
import QuotationPreview from '../../../../components/dashboard/tradeDocuments/previewComponents/QuotationPreview';
import ProformaForm from '../../../../components/dashboard/tradeDocuments/formComponents/ProformaForm';
import useCurrencies from '../../../../customhooks/useCurrencies';
import Addpartnerdrawer from '../addpartnerdrawer/addpartnerdrawer';
import CustomModal from '../../../../components/CustomModal';
import Savetradedocument from '../savetradedocument/savetradedocument';
import { Backdrop } from '@mui/material';
import { TradeDocument } from '../../../../interfaces/TradeDocument';
import { Proforma, ProformaFormErrors } from '../../../../interfaces/Proforma';
import QuotationPreviewMobile from '../../../../components/dashboard/tradeDocuments/previewComponents/QuotationPreviewMobile';

const ProformaInvoiceNew = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [params, setParams] = useState<any>();
    const [loadingData, setLoadingData] = useState(false);
    const [data, setData] = useState<TradeDocument | null>(null);
    const [activeStep, setActiveStep] = useState(0);

    useEffect(() => {
        const searchParams = new URLSearchParams(location.search);
        const param: any = Object.fromEntries(searchParams.entries());
        setParams(param);
    }, [location.search]);

    useEffect(() => {
        if (params?.edit) {
            fetchDocuments();
        }
    }, [params]);

    const { corporatePartners, isLoading } = useCorporatePartners({ page: 1 });

    const fetchDocuments = async () => {
        setLoadingData(true);
        try {
            const res = await getSingleDocuments({
                corporateDocumentId: params?.edit
            });

            const { data } = res.data;
            setData(data);

            setLoadingData(false);
        } catch (error) {
            setLoadingData(false);
            if (error?.response) {
                openNotification('error', `Documents, Something went wrong`);
            } else {
                openNotification('error', `Documents, Something went wrong`);
            }
        }
    };

    const pageTopRef = useRef<any>(null);
    const [partnerId, setPartnerId] = useState<number | undefined>(undefined);
    const myDiv = useRef<HTMLDivElement | null>(null);
    const [showPreview, setShowPreview] = useState(false);
    const [downloadLoading, setDownloadLoading] = useState(false);
    const [signatureUrlBase64, setSignatureUrlBase64] = useState('');
    const [saveOnly, setSaveOnly] = useState(true);
    const [fileId, setFileId] = useState<number | undefined>(undefined);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | any>(null);
    const [payload, setPayload] = useState<Proforma>({
        sellerId: undefined,
        invoiceNumber: nanoid(9),
        invoiceDate: Date.now(),
        receiverId: undefined,
        buyerReference: undefined,
        methodOfDispatch: undefined,
        typeOfShipment: undefined,
        portOfLoadingId: undefined,
        portOfLoadingValue: undefined,
        portOfDischargeId: undefined,
        portOfDischargeValue: undefined,
        additionalInformation: '',
        bankDetails: '',
        issuedDate: Date.now(),
        signatoryCompany: undefined,
        nameOfAuthorisedSignatory: undefined,
        documentName: '',
        logoUrl: '',
        signatureUrl: undefined,
        placeOfIssue: undefined,
        sellerAddress: '',
        receiverAddress: '',
        receiverName: undefined,
        sellerName: undefined,
        salesContractNumber: '',
        stamp: undefined
    });
    const [errors, setErrors] = useState<ProformaFormErrors>({
        sellerId: '',
        invoiceNumber: '',
        invoiceDate: '',
        receiverId: '',
        buyerReference: '',
        methodOfDispatch: '',
        typeOfShipment: '',
        portOfLoadingId: '',
        portOfLoadingValue: '',
        portOfDischargeId: '',
        portOfDischargeValue: '',
        additionalInformation: '',
        bankDetails: '',
        issuedDate: '',
        signatoryCompany: '',
        nameOfAuthorisedSignatory: '',
        documentName: '',
        logoUrl: '',
        signatureUrl: '',
        placeOfIssue: '',
        salesContractNumber: '',
        stamp: ''
    });

    const [totalAmount, setTotalAmount] = useState(0);
    const [quoteFields, setQuoteFields] = useState([
        {
            id: nanoid(9),
            productCode: nanoid(9),
            desc: undefined,
            qty: 0,
            type: undefined,
            price: 0
        }
    ]);

    useEffect(() => {
        if (data) {
            setFileId(data?.id);
            setPayload({
                sellerId: data?.documentData?.sellerId,
                invoiceNumber: data?.documentData?.invoiceNumber || nanoid(9),
                invoiceDate: data?.documentData?.invoiceDate || Date.now(),
                receiverId: data?.documentData?.receiverId,
                buyerReference: data?.documentData?.buyerReference || '',
                methodOfDispatch: data?.documentData?.methodOfDispatch || '',
                typeOfShipment: data?.documentData?.typeOfShipment || '',
                portOfLoadingId: data?.documentData?.portOfLoading.name || '',
                portOfLoadingValue: data?.documentData?.portOfLoading,
                portOfDischargeValue: data?.documentData?.portOfDischarge,
                portOfDischargeId:
                    data?.documentData?.portOfDischarge.name || '',
                additionalInformation:
                    data?.documentData?.additionalInformation || '',
                bankDetails: data?.documentData?.bankDetails || '',
                issuedDate: data?.documentData?.issuedDate || Date.now(),
                signatoryCompany: data?.documentData?.signatoryCompany || '',
                nameOfAuthorisedSignatory:
                    data?.documentData?.nameOfAuthorisedSignatory || '',
                documentName: data?.documentName || '',
                logoUrl: data?.documentData?.logoUrl || '',
                signatureUrl: data?.documentData?.signatureUrl || '',
                placeOfIssue: data?.documentData?.placeOfIssue || '',
                sellerAddress: data?.documentData?.seller?.address || '',
                receiverAddress: data?.documentData?.receiver?.address || '',
                receiverName: data?.documentData?.receiver?.name || '',
                sellerName: data?.documentData?.seller?.address || '',
                salesContractNumber:
                    data?.documentData?.salesContractNumber || '',
                stamp: data?.documentData?.stamp || ''
            });

            const transformArray = (array: any) => {
                const newArray: any = [];
                array.forEach((val: any) => {
                    newArray.push({
                        id: val.id,
                        productCode: val.productCode,
                        desc: val.descriptionOfGoods,
                        qty: val.quantity,
                        type: val.unitType,
                        price: val.unitPrice
                    });
                });
                return newArray;
            };
            setQuoteFields(transformArray(data?.documentData?.items));
        }
    }, [data]);

    const [showSaveModal, setShowSaveModal] = useState(false);

    const [showAddPartner, setShowAddPartner] = useState(false);

    const closeShowAddParty = () => {
        setShowAddPartner(false);
    };

    /**
     * Close save document
     */
    const closeSaveModal = () => {
        setShowSaveModal(false);
    };

    /**
     * Update input fields
     * @param name string
     * @param value any
     */
    const updateField = (name: string, value: any) => {
        setPayload((prevState: any) => ({
            ...prevState,
            [name]: value
        }));
    };

    /**
     * Update quotes input fields
     * @param id string
     * @param name string
     * @param value any
     */
    const updateQuoteField = (
        index: number,
        attributeName: string,
        attributeValue?: any
    ) => {
        const newContainers: any[] = [...quoteFields];
        newContainers[index][attributeName] = attributeValue;
        setQuoteFields(newContainers);
    };

    useEffect(() => {
        let totalNumber = 0;
        quoteFields.forEach((item) => {
            totalNumber +=
                (isNaN(item.price) ? 0 : Number(item.price)) *
                (isNaN(item.qty) ? 0 : Number(item.qty));
        });
        setTotalAmount(totalNumber);
    }, [quoteFields]);

    /**
     * Adds quotes input field line
     */
    const addQuoteField = () => {
        setQuoteFields([
            ...quoteFields,
            {
                id: nanoid(9),
                productCode: nanoid(9),
                desc: undefined,
                qty: 0,
                type: undefined,
                price: 0
            }
        ]);
    };

    /**
     * Remove quotes input field line
     */
    const removeQuoteField = (index: number) => {
        setQuoteFields(quoteFields.filter((item, i) => i !== index));
    };

    const onSubmit = async () => {
        setLoading(true);
        setError(null);

        setErrors((prevState: any) => ({
            ...prevState,
            sellerId: '',
            invoiceNumber: '',
            invoiceDate: '',
            receiverId: '',
            buyerReference: '',
            methodOfDispatch: '',
            typeOfShipment: '',
            portOfLoadingId: '',
            portOfLoadingValue: '',
            portOfDischargeId: '',
            portOfDischargeValue: '',
            additionalInformation: '',
            bankDetails: '',
            issuedDate: '',
            signatoryCompany: '',
            nameOfAuthorisedSignatory: '',
            documentName: '',
            logoUrl: '',
            signatureUrl: '',
            placeOfIssue: '',
            stamp: ''
        }));

        try {
            const items: any[] = [];

            const {
                sellerId,
                invoiceNumber,
                invoiceDate,
                receiverId,
                buyerReference,
                methodOfDispatch,
                typeOfShipment,
                portOfLoadingId,
                portOfLoadingValue,
                portOfDischargeId,
                portOfDischargeValue,
                additionalInformation,
                bankDetails,
                issuedDate,
                signatoryCompany,
                nameOfAuthorisedSignatory,
                documentName,
                logoUrl,
                signatureUrl,
                placeOfIssue,
                salesContractNumber,
                stamp
            } = payload;

            const dischargeValue: any = portOfDischargeValue;
            const portValue: any = portOfLoadingValue;

            quoteFields.forEach((item) => {
                items.push({
                    amount: item.price,
                    descriptionOfGoods: item.desc,
                    productCode: item.productCode,
                    quantity: item.qty,
                    unitPrice: item.price,
                    unitType: item.type
                });
            });

            const res = await createProformaInvoice({
                createdType: 'CREATED',
                documentData: {
                    items,
                    sellerId,
                    invoiceNumber,
                    invoiceDate,
                    receiverId,
                    buyerReference,
                    methodOfDispatch,
                    typeOfShipment,
                    portOfLoadingId: portValue?.id,
                    portOfDischargeId: dischargeValue?.id,
                    additionalInformation,
                    bankDetails,
                    issuedDate,
                    signatoryCompany,
                    nameOfAuthorisedSignatory,
                    logoUrl: logoUrl !== '' ? logoUrl : undefined,
                    signatureUrl,
                    placeOfIssue,
                    totalAmount,
                    salesContractNumber,
                    stamp
                },
                documentType: 'PROFORMA_INVOICE',
                documentName,
                id: fileId
            });

            const { id } = res.data.data;

            setFileId(id);

            openNotification(
                'success',
                'Proforma invoice document created successfully'
            );

            setLoading(false);

            if (saveOnly) {
                navigate('/trade-documents');
            }
        } catch (error) {
            window.scroll({
                top: pageTopRef?.current?.offsetTop,
                left: 0,
                behavior: 'smooth'
            });

            setShowSaveModal(false);
            setLoading(false);
            const otherErrors: any[] = [];
            if (error?.response) {
                if (error?.response?.data?.error) {
                    const resError = error?.response?.data?.error;

                    if (typeof resError === 'string') {
                        const errorList = (
                            <li key={`error-list-${1}`}>{resError}</li>
                        );
                        setError(errorList);
                    } else {
                        Object.entries(resError).forEach(([key, value]) => {
                            if (Object.keys(errors).includes(key)) {
                                setErrors((prevState) => ({
                                    ...prevState,
                                    [key]: value
                                }));
                            } else {
                                otherErrors.push(value);
                            }
                        });

                        if (otherErrors.length > 0) {
                            const errorList = otherErrors.map(
                                (element: any, index) => {
                                    return (
                                        <li key={`error-list-${index}`}>
                                            {element}
                                        </li>
                                    );
                                }
                            );
                            setError(errorList);
                        }
                    }
                } else {
                    setError(
                        error?.response?.data?.message || 'Something went wrong'
                    );
                }
            } else {
                setError('Something went wrong');
            }
        }
    };

    const breadcrumbs = [
        {
            title: 'Home',
            link: '/',
            active: false
        },
        {
            title: 'Documents',
            link: '/trade-documents',
            active: false
        },
        {
            title: 'Proforma Invoice',
            link: '/trade-documents/proforma-invoice',
            active: true
        }
    ];

    const { isLoading: isLoadingCurrencies, currencies } = useCurrencies();

    return (
        <TradeContainer>
            <FormHeader
                breadcrumbs={breadcrumbs}
                docTitle='Proforma Invoice'
                {...{
                    showPreview,
                    setShowPreview,
                    myDiv,
                    downloadLoading,
                    setDownloadLoading
                }}
                onSaveOnlyAction={() => {
                    setSaveOnly(true);
                    setShowSaveModal(true);
                }}
                onSaveAction={() => {
                    setSaveOnly(false);
                    setShowSaveModal(true);
                }}
                disabled={
                    Object.values(payload).some(
                        (item: any) => item === undefined
                    ) || loading
                }
                steps={2}
                activeStep={activeStep}
            />

            <TradeContent>
                <Backdrop
                    sx={{
                        color: '#fff',
                        zIndex: (theme) => theme.zIndex.drawer + 1
                    }}
                    open={loadingData}
                >
                    <img
                        src='/img/vectors/loadingcircles.svg'
                        alt='loading'
                        className='animate-spin'
                    />
                </Backdrop>
                {showPreview ? (
                    <>
                        <div
                            ref={myDiv}
                            className='hidden lg:block print:block'
                        >
                            <QuotationPreview
                                data={payload}
                                docTitle='Proforma Invoice'
                                quoteFields={quoteFields}
                                totalAmount={totalAmount}
                                signatureUrlBase64={signatureUrlBase64}
                            />
                        </div>
                        <div className='lg:hidden print:hidden'>
                            <QuotationPreviewMobile
                                data={payload}
                                docTitle='Proforma Invoice'
                                quoteFields={quoteFields}
                                totalAmount={totalAmount}
                                signatureUrlBase64={signatureUrlBase64}
                            />
                        </div>
                    </>
                ) : (
                    <ProformaForm
                        {...{
                            error,
                            updateField,
                            payload,
                            corporatePartners,
                            loadingCorporatepartners: isLoading,
                            setShowAddPartner,
                            errors,
                            quoteFields,
                            updateQuoteField,
                            removeQuoteField,
                            currencies,
                            addQuoteField,
                            loading,
                            loadingCurrencies: isLoadingCurrencies,
                            setSignatureUrlBase64,
                            signatureUrlBase64,
                            setSaveOnly,
                            setShowSaveModal,
                            totalAmount,
                            setPartnerId,
                            activeStep,
                            setActiveStep,
                            showPreview,
                            setShowPreview
                        }}
                        onSaveOnlyAction={() => {
                            setSaveOnly(true);
                            setShowSaveModal(true);
                        }}
                    />
                )}
                {showAddPartner ? (
                    <Addpartnerdrawer
                        // corporateId={user?.corporate_id}
                        closeDrawer={closeShowAddParty}
                        showDrawer={showAddPartner}
                        partnerId={partnerId}
                        setPartnerId={setPartnerId}
                    />
                ) : null}
                {showSaveModal && (
                    <CustomModal
                        open={showSaveModal}
                        onClose={closeSaveModal}
                        title='Saving document'
                        maxWidth='xs'
                    >
                        <Savetradedocument
                            updateField={updateField}
                            onSubmit={onSubmit}
                            loading={loading}
                            data={payload}
                        />
                    </CustomModal>
                )}
            </TradeContent>
        </TradeContainer>
    );
};

export default ProformaInvoiceNew;
